export const toTitleCase = (str) => {
  if (!str || typeof str !== 'string') return str ?? '';
  return str
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/(^|\.\s*)([a-z])/g, (match, sep, char) => sep + char.toUpperCase())
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
